import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MenuItemLocal} from '../menu-item.model';
import {MenuService} from '../menu.service';

@Component({
    selector: 'app-sub-menu',
    templateUrl: './sub-menu.component.html',
    styleUrls: ['./sub-menu.component.scss'],
    standalone: false
})
export class SubMenuComponent implements OnInit {
  @Input() menuArray: MenuItemLocal[];
  @Input() isDesktop: boolean;
  @Input() isConfigMode: boolean;

  @Output() linkSelected = new EventEmitter();
  @Output() favoriteMenuSelected = new EventEmitter();

  constructor(private menuService: MenuService) {
  }

  public selectLink() {
    this.linkSelected.emit();

    if (!this.isDesktop) {
      this.menuService.isCollapsed.next(true);
    }
  }

  public isActiveLink(location) {
    return window.location.hash.startsWith(location);
  }

  ngOnInit() {
    return;
  }

  selectMenu(event, menu: any) {
    event.stopPropagation();
    menu.visible = !menu.visible;
    this.favoriteMenuSelected.emit();
  }

}
